import { useTranslation } from 'react-i18next';

import { TableHead, TableHeader, TableRow } from '@/common/components/ui/table';

import { RenewalSortField } from '../types/SortTypes';
interface RenewalHeaderProps {
  onSort: (field: RenewalSortField) => void;
}

const FIRST_LEVEL_CLASS =
  'font-semibold outline border-r outline-border bg-white';

export const RenewalHeader = ({ onSort }: RenewalHeaderProps) => {
  const { t } = useTranslation();

  const handleSort = (field: RenewalSortField) => {
    onSort(field);
  };

  return (
    <TableHeader className="sticky top-0 z-10 bg-background">
      <TableRow className="border-b-2">
        <TableHead colSpan={5} className={FIRST_LEVEL_CLASS}>
          {t('renewal.priorisation')}
        </TableHead>
        <TableHead colSpan={4} className={FIRST_LEVEL_CLASS}>
          {t('renewal.policyIdentification')}
        </TableHead>
        <TableHead colSpan={3} className={FIRST_LEVEL_CLASS}>
          {t('renewal.renewal')}
        </TableHead>
        <TableHead colSpan={2} className={FIRST_LEVEL_CLASS}>
          {t('renewal.contractContext')}
        </TableHead>
        <TableHead colSpan={3} className={FIRST_LEVEL_CLASS}>
          {t('renewal.compensationAndFees')}
        </TableHead>
      </TableRow>
      <TableRow>
        <TableHead
          className="cursor-pointer hover:bg-muted/50 whitespace-nowrap border-r border-border"
          onClick={() => handleSort('expiration')}
        >
          <div className="flex items-center gap-1">
            {t('renewal.expiration')}
          </div>
        </TableHead>
        <TableHead className="whitespace-nowrap border-r border-border">
          {t('renewal.alert')}
        </TableHead>
        <TableHead className="whitespace-nowrap border-r border-border">
          {t('renewal.notes')}
        </TableHead>
        <TableHead className="whitespace-nowrap border-r border-border">
          {t('renewal.status')}
        </TableHead>
        <TableHead className="whitespace-nowrap border-r border-border">
          {t('renewal.assignedTo')}
        </TableHead>
        <TableHead
          className="cursor-pointer hover:bg-muted/50 whitespace-nowrap border-x border-border"
          onClick={() => handleSort('company')}
        >
          <div className="flex items-center gap-1">{t('renewal.company')}</div>
        </TableHead>
        <TableHead
          className="cursor-pointer hover:bg-muted/50 whitespace-nowrap border-r border-border"
          onClick={() => handleSort('policyNumber')}
        >
          <div className="flex items-center gap-1">
            {t('renewal.policyNumber')}
          </div>
        </TableHead>
        <TableHead className="whitespace-nowrap border-r border-border">
          {t('renewal.type')}
        </TableHead>
        <TableHead className="whitespace-nowrap border-r border-border">
          {t('renewal.insurer')}
        </TableHead>
        <TableHead
          className="cursor-pointer hover:bg-muted/50 whitespace-nowrap text-right border-x border-border"
          onClick={() => handleSort('currentPremium')}
        >
          <div className="flex items-center justify-end gap-1">
            {t('renewal.currentPremium')}
          </div>
        </TableHead>
        <TableHead
          className="cursor-pointer hover:bg-muted/50 whitespace-nowrap text-right border-r border-border"
          onClick={() => handleSort('renewalPremium')}
        >
          <div className="flex items-center justify-end gap-1">
            {t('renewal.renewalPremium')}
          </div>
        </TableHead>
        <TableHead className="whitespace-nowrap text-right border-r border-border">
          {t('renewal.premiumVariation')}
        </TableHead>
        <TableHead className="whitespace-nowrap text-center border-x border-border">
          {t('renewal.amendments')}
        </TableHead>
        <TableHead className="whitespace-nowrap text-center border-r border-border">
          {t('renewal.claims')}
        </TableHead>
        <TableHead className="whitespace-nowrap text-right border-x border-border">
          {t('renewal.commissionPercentage')}
        </TableHead>
        <TableHead className="whitespace-nowrap text-right border-r border-border">
          {t('renewal.fees')}
        </TableHead>
        <TableHead className="whitespace-nowrap text-right border-r border-border">
          {t('renewal.insurerFees')}
        </TableHead>
      </TableRow>
    </TableHeader>
  );
};
